/* rc-card — image rail: CLICK a dot to change image, or SWIPE the image (touch) to
   go to the next / previous photo. Event-delegated + idempotent so it works for
   AJAX-added cards (collection filter / load-more / carousel clones). Shared by the
   PLP cards and the Featured Chassis image rail. Load once with defer. */
(function () {
  if (window.__rcCardInit) return;
  window.__rcCardInit = true;

  function setSlide(card, idx) {
    var imgs = card.querySelectorAll('[data-rc-slide]');
    var dots = card.querySelectorAll('[data-rc-dot]');
    imgs.forEach(function (img) {
      img.classList.toggle('is-active', parseInt(img.dataset.rcSlide, 10) === idx);
    });
    dots.forEach(function (dot) {
      var on = parseInt(dot.dataset.rcDot, 10) === idx;
      dot.classList.toggle('is-active', on);
      if (dot.getAttribute('role') === 'tab') dot.setAttribute('aria-selected', on ? 'true' : 'false');
    });
  }

  function activeIndex(card) {
    var i = 0;
    card.querySelectorAll('[data-rc-dot]').forEach(function (d) {
      if (d.classList.contains('is-active')) i = parseInt(d.dataset.rcDot, 10);
    });
    return i;
  }

  // Click a dot → show that image. (Hover-to-change was removed by request.)
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-rc-dot]');
    if (!dot) return;
    e.preventDefault();
    var card = dot.closest('[data-rc-card]');
    if (card) setSlide(card, parseInt(dot.dataset.rcDot, 10));
  });

  // Touch swipe → next / previous photo. Skipped inside a horizontal carousel, which
  // owns horizontal drags (rc-carousel.js); mouse keeps the dots.
  var startX = 0, startY = 0, swipeCard = null, didSwipe = false;
  document.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse') return;
    var card = e.target.closest('[data-rc-card]');
    if (!card || card.closest('[data-rc-carousel]')) return;
    swipeCard = card; startX = e.clientX; startY = e.clientY; didSwipe = false;
  }, true);
  document.addEventListener('pointerup', function (e) {
    if (!swipeCard) return;
    var card = swipeCard; swipeCard = null;
    var dx = e.clientX - startX, dy = e.clientY - startY;
    if (Math.abs(dx) < 40 || Math.abs(dx) <= Math.abs(dy)) return; // not a horizontal swipe
    var count = card.querySelectorAll('[data-rc-dot]').length;
    if (count < 2) return;
    var next = activeIndex(card) + (dx < 0 ? 1 : -1);
    next = Math.max(0, Math.min(count - 1, next));
    setSlide(card, next);
    didSwipe = true;
  }, true);
  // Swallow the click a swipe leaves behind so it doesn't open the car page.
  document.addEventListener('click', function (e) {
    if (didSwipe) { didSwipe = false; e.preventDefault(); e.stopPropagation(); }
  }, true);
})();
